import { STR_ERRORS } from "../../../Strings";
import { connectionStore, SDQuerySubscribersStore, ClearConnectionResults } from "../../../Stores";
import { shouldUnsubscribe, getPrevQueryID, getPrevQuery } from ".";
import { ConfigStore } from "../../../Stores";
var timeout = undefined;
export function applyQueries(connectionName, r) {
    const conn = connectionStore.get(connectionName);
    if (typeof conn === "undefined") {
        throw new Error(STR_ERRORS.NoConnectionsAvailable);
    }
    if (typeof r.query === "undefined") {
        const x = SDQuerySubscribersStore.clearConnection(r);
        if (x !== ClearConnectionResults.RemovedConnection &&
            x !== ClearConnectionResults.QueryNotFound) {
            conn.send({
                name: "Unsubscribe",
                params: { id: x }
            });
        }
        if (SDQuerySubscribersStore.getAllConnections().length === 0) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                // code available only in debug builds is excluded from coverage
                /* istanbul ignore next */
                if (process.env.NODE_ENV === "development") {
                    console.warn(`Called connection.deactivate() due to inactivity for ${ConfigStore.config.connections.inactiveTTL_MS} ms.`);
                }
                conn.deactivate().catch(console.error);
            }, ConfigStore.config.connections.inactiveTTL_MS);
        }
        return x;
    }
    clearTimeout(timeout);
    // Get query details from the store before we set the new query
    const qID = SDQuerySubscribersStore.getQueryID(r.query);
    const qPrevID = getPrevQueryID(r);
    const qPrev = getPrevQuery(qPrevID);
    SDQuerySubscribersStore.set(r.query, r);
    return conn.isConnected()
        .then(x => x ? x : conn.connect())
        .then(x => {
        // Here we know that the WebSocket state "isOpened" is true and we
        // can call conn.send().
        if (shouldUnsubscribe(qID, qPrev)) {
            conn.send({
                name: "Unsubscribe",
                params: { id: qID || qPrevID }
            });
        }
        conn.send(r.query);
        return x;
    })
        .catch(console.error);
}
//# sourceMappingURL=applyQueries.js.map